import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { commonComponentsRegistry } from '../registry/CommonRegistry';

const Container = commonComponentsRegistry.getLazyComponent('Container');

// TODO: when we use it more globally, we will wanted to add a common header to not repeat it.
// an exemple is in the @TwoColLayout component.
// Currently (2025-08-20), calendar and accessibility are the only components that use it.
export const FullPageLayout = () => {
    return (
        <Suspense fallback={<></>}>
            <Container backgroundColor={'white'} mode={'fluid'} flexDirection={'column'}>
                <Outlet />
            </Container>
        </Suspense>
    );
};
